import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { ExportComponent } from './export.component';

export const ExportStates : Array<NgHybridStateDeclaration> = [
  {
    component: ExportComponent,
    name     : 'app.export',
    url      : '/export'
  }
];
